import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '@/components/homePage';
import QRScanner from '@/components/QRScanner';
import EventScanner from '@/components/EventScanner';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
    },
    {
      path: '/:code',
      name: 'QRScanner',
      component: QRScanner,
    },
    {
      path: '/event/:id',
      name: 'EventScanner',
      component: EventScanner,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js